export default "/imgs/tag/vice_chairman.svg"